import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from '@brighterion/br-ui';
import styles from './TableLoading.css';

type Props = {
    searchFilter: string;
    noDataMessage: string;
    isLoading: boolean;
};

const TableLoading = ({ searchFilter, noDataMessage, isLoading }: Props) => {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <Loading size='md' />
            </div>
        );
    }

    const text = searchFilter ? t('table no data with params', { searchParams: searchFilter }) : t(noDataMessage);
    return (
        <div data-testid='table-no-data-msg' className={styles.noDataMessage}>
            {text}
        </div>
    );
};

export default TableLoading;
